import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=6239e038&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"
import style0 from "../Style/template.scss?vue&type=style&index=0&id=6239e038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239e038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6239e038')) {
      api.createRecord('6239e038', component.options)
    } else {
      api.reload('6239e038', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=6239e038&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('6239e038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Template.vue"
export default component.exports